import { render, staticRenderFns } from "./ClassVideoPage.vue?vue&type=template&id=36ae8a00&"
import script from "./ClassVideoPage.vue?vue&type=script&lang=js&"
export * from "./ClassVideoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports